export const NETWORK_OPTIONS = [
  { value: 'default', label: 'Default' },
  { value: 'adnet', label: 'Adnet' },
  { value: 'xml', label: 'XML' },
] as const;

export const XML_SAMPLE_PLACEHOLDER = `<result>
    <listing title="Ad title" descr="first offer" site="site.com" bid="0.5"/>
    <listing title="Ad title 2" descr="second offer" site="site2.com" bid="0.6"/>
</result>`;

